import { render } from "./AddPartMileage.vue?vue&type=template&id=6d32272c"
import script from "./AddPartMileage.vue?vue&type=script&lang=js"
export * from "./AddPartMileage.vue?vue&type=script&lang=js"
script.render = render

export default script